import React from 'react';

import FieldText from '../common/conditional-field/FieldText';
import FieldTextArea from '../common/conditional-field/FieldTextArea';
import FieldNumber from '../common/conditional-field/FieldNumber';
import FieldDecimal from '../common/conditional-field/FieldDecimal';
import FieldDate from '../common/conditional-field/FieldDate';
import FieldDateTime from '../common/conditional-field/FieldDateTime';
import FieldMultiSelect from '../common/conditional-field/FieldMultiSelect';
import FieldSelect from '../common/conditional-field/FieldSelect';
import FieldAddress from '../common/conditional-field/FieldAddress';
import FieldToggle from '../common/conditional-field/FieldToggle';
import FieldPhone from '../common/conditional-field/FieldPhone';
import FieldMultiValue from '../common/conditional-field/FieldMultiValue';

import Const from '../../util/Constants';
import FieldLocation from '../common/FieldLocation';

class ModelAddUpdateGroup extends React.Component {

  getCustomFields = (module, fields, ConditionalFields, model, onValueChange, inValid) => {
    const list = [];
    for (let i = 0; i < fields.length; i++) {
      const key = fields[i];
      const field = module.fields[key];
      if(!field) {
        continue;
      }
      const type = field.field_type;
      const value = model[key];

      const ConditionalField = ConditionalFields.find(item => item.field === key);

      const visible = ConditionalField.visible;
      const editable = ConditionalField.editable;
      const mandatory = ConditionalField.mandatory;
      const options = ConditionalField.options;
      const error = ConditionalField.error;
      const errorMessage = ConditionalField.errorMessage;

      const innerData = {
      //  key: key,
        id: key,
        field,
        value,
        onValueChange,
        inValid,
        visible,
        editable,
        mandatory,
        options,
        error,
        errorMessage
      };

      if (type === Const.Text) list.push(<FieldText key={key} {...innerData} />);
      else if (type === Const.TextArea) list.push(<FieldTextArea key={key} {...innerData} />);
      else if (type === Const.Number) list.push(<FieldNumber key={key} {...innerData} />);
      else if (type === Const.Decimal) list.push(<FieldDecimal key={key} {...innerData} />);
      else if (type === Const.Date) list.push(<FieldDate key={key} {...innerData} />);
      else if (type === Const.DateTime) list.push(<FieldDateTime key={key} {...innerData} />);
      else if (type.includes(Const.MultiSelect)) list.push(<FieldMultiSelect key={key} {...innerData} />);
      else if (type.includes(Const.Select)) list.push(<FieldSelect key={key} {...innerData} />);
      else if (type === Const.Toggle) list.push(<FieldToggle key={key} {...innerData} />);
      else if (type === Const.Phone) list.push(<FieldPhone key={key} {...innerData} />);
      else if (type === Const.Email || type === Const.MultiValue) list.push(<FieldMultiValue key={key} {...innerData} />);
      else if (type === Const.Address) list.push(<FieldAddress key={key} {...innerData} />);
      else if (type === Const.Location) list.push(<FieldLocation key={key} {...innerData} />);
    }
    return list;
  };

  render() {
    const design = this.props.design;
    const model = this.props.model;
    const onValueChange = this.props.onValueChange;
    const inValid = this.props.inValid;
    const ConditionalFields = this.props.conditionalFields;

    const list = this.getCustomFields(this.props.module, design.fields, ConditionalFields, model, onValueChange, inValid);
    if (list.length === 0) {
      return null;
    }
    
    return (
      <>
        <div className="formhead col-md-12">
          <h2>{this.props.design.title}</h2>
        </div>
        {list}
      </>
    );
  }
}

export default ModelAddUpdateGroup;